import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import defaultImage from "../../../images/summary_progress.svg";

/**
 * WaveformLayout - Shared layout with waveform image and an overlapping circle icon.
 * Used by AimsNotAvailable (warning icon) and RtmsRestartLoading (loader).
 */
const WaveformLayout = ({ icon, children }) => {
  return (
    <>
      <Row height="48px"/>
      <Row spacing="none">
        <Column width="13px"/>
        <div style={{ position: "relative" }}>
          <img src={defaultImage} alt="" />
          <div style={{ position: "absolute", bottom: -32, left: 32, width: 64, height: 64, borderRadius: "50%", border: "1px solid #FFFFFF", backgroundColor: "#FFF", display: "flex", alignItems: "center", justifyContent: "center" }}>
            {icon}
          </div>
        </div>
      </Row>
      <Row spacing="none">
        <Column width="67px"/>
        <Column alignmentHorizontal="start" spacing="none" width="238px">
          <Row height="57px"/>
          {children}
        </Column>
      </Row>
    </>
  );
};

export default WaveformLayout;
